package org.moxultimate.topwithmox.pages

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.core.data.add
import com.varabyte.kobweb.core.data.getValue
import com.varabyte.kobweb.core.init.InitRoute
import com.varabyte.kobweb.core.init.InitRouteContext
import com.varabyte.kobweb.core.layout.Layout
import com.varabyte.kobweb.core.rememberPageContext
import org.moxultimate.topwithmox.components.layouts.PageLayoutData
import org.moxultimate.topwithmox.wallpaper.details.WallpaperDetailsPage

/** Thin wrapper so [ctx.data] can carry the wallpaper id to the @Page composable. */
data class WallpaperIdHolder(val id: Long)

@InitRoute
fun initWallpaperDetailsRoute(ctx: InitRouteContext) {
    ctx.data.add(PageLayoutData("Wallpaper Details"))
    // URLSearchParams reads the browser query string (?id=…) — works for direct links and shared URLs
    val urlParams: dynamic = js("new URLSearchParams(window.location.search)")
    val id = (urlParams.get("id") as? String)?.toLongOrNull() ?: 0L
    ctx.data.add(WallpaperIdHolder(id))
}

@Page(routeOverride = "wallpaperdetails")
@Layout(".components.layouts.PageLayout")
@Composable
fun WallpaperDetailsRoute() {
    val ctx = rememberPageContext()
    val holder = ctx.data.getValue<WallpaperIdHolder>()
    WallpaperDetailsPage(wallpaperId = holder.id)
}
